import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { breakpoints } from '../../constants';

interface IProps {
    packageName: string;
    className?: string;
}

const BasePackageNameDisplay = ({
    packageName,
    className,
}: IProps) => {
    const { t: translate } = useTranslation();

    return (
        <h3 className={className}>
            {packageName}
            <br />
            <span>{translate('glassesPackage')}</span>
        </h3>
    );
};

export const PackageNameDisplay = styled(BasePackageNameDisplay)`
    font-size: 24px;
    line-height: 1;
    margin-bottom: 20px;

    @media (${breakpoints.mediumMin}) {
        margin-bottom: 0;
    }

    span {
        font-weight: 400;
    }
`;
